import { graphql, useStaticQuery } from 'gatsby';

export default function useGraphqlImage() {
  const mentorSectionImgNode = useStaticQuery(graphql`
    query {
      Thumbnail: allFile(
        filter: { relativePath: { regex: "images/mentors/" } }
      ) {
        nodes {
          name
          relativePath
          childImageSharp {
            gatsbyImageData(
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
    }
  `);
  return {
    mentorSectionImgNode,
  };
}
